import { useEffect, useRef, useState } from 'react'
import { useMemorama } from '../../context/MemoramaContext'
import { useLanguage } from '@context/LanguageContext'
import { useFocusTrap } from '@hooks/useFocusTrap'
import { useEscapeKey } from '@hooks/useEscapeKey'
import { useAutoFocus } from '@hooks/useAutoFocus'
import { getSessionItem, setSessionItem } from '@utils/storage'
import styles from './OrientationModal.module.css'
import baseStyles from '@styles/modalBase.module.css'

export default function OrientationModal () {
  const { boardSize } = useMemorama()
  const { t } = useLanguage()
  const modalRef = useRef(null)
  const messageRef = useRef(null)
  const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth)
  const [dismissed, setDismissed] = useState(() => getSessionItem('hideOrientationHint') === 'true')
  const [visible, setVisible] = useState(false)

  const handleDismiss = () => {
    setSessionItem('hideOrientationHint', 'true')
    setDismissed(true)
  }

  const handleConfirm = () => {
    setVisible(false)
  }

  useFocusTrap(modalRef)
  useEscapeKey(handleDismiss, visible)
  useAutoFocus(messageRef, visible)

  // Monitor orientation changes
  useEffect(() => {
    const handleResize = () => {
      setIsPortrait(window.innerHeight > window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Determine if board is large
  const largeSizes = ['l', 'xl', '2xl', '3xl']
  const isLargeBoard = largeSizes.includes(boardSize)

  // Minimum height threshold (exclude phones)
  const isTabletSize = window.innerHeight >= 800

  useEffect(() => {
    const shouldShow = isPortrait && isTabletSize && isLargeBoard && !dismissed
    setVisible(shouldShow)
  }, [isPortrait, isTabletSize, isLargeBoard, dismissed])

  if (!visible) return null

  return (
    <div
      className={baseStyles.overlayTop}
      role='dialog'
      aria-modal='true'
      aria-labelledby='orientation-message'
    >
      <div className={styles.orientationModal} ref={modalRef}>
        <img
          src='/mobile-rotate.svg'
          alt='Icono de rotación de dispositivo'
          className={styles.icon}
          aria-hidden='true'
          loading='lazy'
          decoding='async'
        />

        <div className={styles.message}>
          <h2
            id='orientation-message'
            ref={messageRef}
            tabIndex='-1'
          >
            {t.memorama.orientation.message}
          </h2>
        </div>

        <button
          className={styles.okBtn}
          onClick={handleConfirm}
        >
          {t.memorama.orientation.confirm}
        </button>
        <button
          className={styles.dismissBtn}
          onClick={handleDismiss}
        >
          {t.memorama.orientation.dismiss}
        </button>
        <div className={baseStyles.topHandle} />
      </div>
    </div>
  )
}
